const brands = {
    "heroarts.com": "HEROARTS",
    "spellbinders.com": "SPELLBINDERS",
    "spellbinderpaperarts.com": "SPELLBINDERS"
};

class CartAttributeManager {
    constructor() {
        this.brands = brands;

        if (!window.cartAttributes) {
            window.cartAttributes = {};
        }

        this.ready = this.initialize();
    }

    getBrand() {
        const hostname = window.location.hostname
            .toLowerCase()
            .replace(/^www\./, "");

        for (const [domain, brand] of Object.entries(this.brands)) {
            if (hostname === domain || hostname.endsWith(`.${domain}`)) {
                return brand;
            }
        }

        return null;
    }

    get(name) {
        return window.cartAttributes[name];
    }

    getAll() {
        return window.cartAttributes;
    }

    has(name) {
        return Object.prototype.hasOwnProperty.call(
            window.cartAttributes,
            name
        );
    }

    async add(name, value) {
        if (!name) {
            throw new Error("Cart attribute name is required.");
        }

        return this.update({
            [name]: value
        });
    }

    async remove(name) {
        if (!name) {
            throw new Error("Cart attribute name is required.");
        }

        return this.update({
            [name]: null
        });
    }

    async refresh() {
        const response = await fetch("/cart.js", {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        });

        if (!response.ok) {
            throw new Error(
                `Unable to get cart. Status: ${response.status}`
            );
        }

        const cart = await response.json();

        window.cartAttributes = {
            ...(cart.attributes || {})
        };

        return window.cartAttributes;
    }

    async update(attributes) {
        const response = await fetch("/cart/update.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify({
                attributes
            })
        });

        if (!response.ok) {
            throw new Error(
                `Unable to update cart. Status: ${response.status}`
            );
        }

        const cart = await response.json();

        window.cartAttributes = {
            ...(cart.attributes || {})
        };

        return window.cartAttributes;
    }

    async applyBrand() {
        const brand = this.getBrand();

        if (!brand) {
            return;
        }

        if (this.has("brand")) {
            return;
        }

        await this.add("brand", brand);
    }

    async initialize() {
        try {
            await this.refresh();
            await this.applyBrand();

            return window.cartAttributes;
        } catch (error) {
            console.error( "CartAttributeManager initialization failed:", error );

            return window.cartAttributes;
        }
    }
}

if (!window.cartAttributeManager) {
    window.cartAttributeManager = new CartAttributeManager();
}